import { render, staticRenderFns } from "./FormTags.vue?vue&type=template&id=285e4b2c"
import script from "./FormTags.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormTags.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports